<template>
  <div>
    <section class="container">
      <ul v-if="details != ''">
        <li class="disBlock">
          <h3>{{ details.name }}</h3>
        </li>
        <li class="disBlock">
          <label>手机号：</label>
          <p>{{ details.phone }}</p>
        </li>
        <li class="disBlock">
          <label>身份证号：</label>
          <p>{{ details.id_card }}</p>
        </li>
        <li class="disBlock">
          <label>项目：</label>
          <p>{{ details.project_name }}</p>
        </li>
        <li class="disBlock">
          <label>日期：</label>
          <p>{{ details.month_date }}</p>
        </li>
        <li
          v-show="details.float_data_config != ''"
          v-for="(item, k) in details.float_data_config"
          :key="k"
        >
          <label>{{ item.name + "：" }}</label>
          <p>{{ item.value }}</p>
        </li>
        <li>
          <label>收入基数：</label>
          <p>{{ Number(details.base_salary) + "元" }}</p>
        </li>
        <li>
          <label>出勤天数（不含病假及三薪天数）</label>
          <p>{{ Number(details.work_day) + "天" }}</p>
        </li>
        <li>
          <label>出勤收入：</label>
          <p>{{ Number(details.work_salary) + "元" }}</p>
        </li>
        <li>
          <label>三薪天数：</label>
          <p>{{ Number(details.three_salary_day) + "天" }}</p>
        </li>
        <li>
          <label>三薪收入：</label>
          <p>{{ Number(details.three_salary_money) + "元" }}</p>
        </li>
        <li>
          <label>出勤收入合计：</label>
          <p>{{ Number(details.work_total) + "元" }}</p>
        </li>
        <li>
          <label>补贴：</label>
          <p>{{ Number(details.subsidy) + "元" }}</p>
        </li>
        <li>
          <label>拉新提成：</label>
          <p>{{ Number(details.new_salary) + "元" }}</p>
        </li>
        <li>
          <label>7日复购数量：</label>
          <p>{{ Number(details.seven_again) }}</p>
        </li>
        <li>
          <label>7日复购提成：</label>
          <p>{{ Number(details.seven_salary) + "元" }}</p>
        </li>
        <li>
          <label>老客会员卡提成:</label>
          <p>{{ Number(details.old_salary) + "元" }}</p>
        </li>
        <li>
          <label>新人激励金额：</label>
          <p>{{ Number(details.new_inspire_salary) + "元" }}</p>
        </li>
        <li>
          <label>冲单激励合计：</label>
          <p>{{ Number(details.order_inspire_total) + "元" }}</p>
        </li>
        <li>
          <label>管理扣款：</label>
          <p>{{ Number(details.manage_deduction) + "元" }}</p>
        </li>
        <li>
          <label>个税：</label>
          <p>{{ Number(details.personal_income) + "元" }}</p>
        </li>
        <li>
          <label>保险：</label>
          <p>{{ Number(details.insurance) + "元" }}</p>
        </li>
        <li>
          <label>其他：</label>
          <p>{{ Number(details.other) + "元" }}</p>
        </li>
        <li>
          <label>系统预支：</label>
          <p>{{ Number(details.pre_amount) + "元" }}</p>
        </li>
        <li>
          <label>线下预支：</label>
          <p>{{ Number(details.pre_in) + "元" }}</p>
        </li>
        <li>
          <label>应发：</label>
          <p>{{ Number(details.pre_provide) + "元" }}</p>
        </li>
        <li>
          <label>实发：</label>
          <p>{{ Number(details.provide) + "元" }}</p>
        </li>
      </ul>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      details: {}
    };
  },
  mounted() {
    if (this.detailsVal != undefined) {
      this.details = this.detailsVal;
    }
    // console.log(this.detailsVal);
  },
  props: {
    detailsVal: {}
  },
  watch: {
    detailsVal() {
      this.details = this.detailsVal;
      // console.log(this.detailsVal);
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  margin: 30px 2%;
  > ul {
    > li {
      display: inline-block;
      min-width: 33%;
      margin-bottom: 10px;
      h3 {
        font-size: 20px;
        line-height: 30px;
      }
      p,
      label {
        display: inline-block;
        font-size: 14px;
        line-height: 24px;
      }
    }
    .disBlock {
      display: block;
    }
  }
}
</style>
